module.exports = __webpack_public_path__ + "img/image-balanced.8ce718d6.png";